const ENVIRONMENT = (process.env.REACT_APP_RUN_ENV ?? 'local') as
  | 'local'
  | 'test'
  | 'storybook'
  | 'development'
  | 'testing'
  | 'acceptance'
  | 'production';

export type Environment = typeof ENVIRONMENT;

export default ENVIRONMENT;
